export default {
    details: {
        height: "100%",
        padding: 3
    },
    fullHeight: {
        height: "100%"
    },
    marginRight: {
        marginRight: 1
    },
    noMarginBottom: {
        marginBottom: 0
    },
    loadingIcon: {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        margin: "auto"
    },
    smallLoading: {
        width: "100%",
        textAlign: "center",
        marginTop: 2
    },
    tabPanelContainer: {
        height: "50vh"
    },
    messageContainer: {
        textAlign: "center",
        margin: 3
    },
    formControl: {
        margin: 1,
        "& svg": {
            color: "primary.main"
        }
    },
    loadingStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
    }
};
